import React, { Component } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import RiskPagination from '../../risk/RiskPagination';

function initials(person) {
    if (!person) return '—';
    const a = (person.first_name || '').trim()[0] || '';
    const b = (person.first_last_name || '').trim()[0] || '';
    return (a + b) || '—';
}
function fullName(person) {
    if (!person) return '—';
    return `${person.first_name || ''} ${person.first_last_name || ''}`.trim() || '—';
}

class TableIndexWeb extends Component {
    constructor(props) {
        super(props);
        this.state = { page: 1, perPage: 10 };
    }

    render() {
        const { estados } = this.props;
        const data = this.props.data || [];
        const total = data.length;
        const totalPages = Math.max(1, Math.ceil(total / this.state.perPage));
        const page = Math.min(this.state.page, totalPages);
        const pageData = data.slice((page - 1) * this.state.perPage, page * this.state.perPage);
        const showActions = estados.editar || estados.eliminar || estados.gestionar;

        return (
            <div className="rk-wrap">
                <div className="rk-table-card">
                    <div className="rk-table-scroll">
                        <table className="rk-table">
                            <thead>
                                <tr>
                                    <th className="rk-table__num">#</th>
                                    <th>Proceso</th>
                                    <th>Fecha de análisis</th>
                                    <th>Responsable</th>
                                    {showActions && <th className="rk-table__actions"></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {total >= 1 ? (
                                    pageData.map((efect, i) => (
                                        <tr key={efect.id}>
                                            <td className="rk-table__num">{(page - 1) * this.state.perPage + i + 1}</td>
                                            <td className="rk-cell-primary">{efect.proceso || '—'}</td>
                                            <td className="rk-cell-muted">{efect.date_of_analysis || '—'}</td>
                                            <td>
                                                <span className="rk-person">
                                                    <span className="rk-avatar">{initials(efect.responsable)}</span>
                                                    {fullName(efect.responsable)}
                                                </span>
                                            </td>
                                            {showActions && (
                                                <td className="rk-table__actions">
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle tag="button" className="rk-icon-btn">
                                                            <i className="fas fa-ellipsis-v"></i>
                                                        </DropdownToggle>
                                                        <DropdownMenu right className="rk-menu">
                                                            {estados.gestionar && (
                                                                <DropdownItem
                                                                    href={`/failure/efects/${efect.id}/efect_activities`}
                                                                    data-turbolinks="true"
                                                                >
                                                                    <i className="fas fa-cog"></i> Gestionar
                                                                </DropdownItem>
                                                            )}
                                                            {estados.editar && (
                                                                <DropdownItem onClick={() => this.props.edit(efect)}>
                                                                    <i className="fas fa-pen"></i> Editar
                                                                </DropdownItem>
                                                            )}
                                                            {estados.eliminar && (
                                                                <DropdownItem
                                                                    className="rk-danger"
                                                                    onClick={() => this.props.delete(efect.id)}
                                                                >
                                                                    <i className="fas fa-trash"></i> Eliminar
                                                                </DropdownItem>
                                                            )}
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={showActions ? 5 : 4}>
                                            <div className="rk-empty">
                                                <i className="far fa-folder-open"></i>
                                                <p>No hay registros AMEF</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <RiskPagination
                        page={page}
                        perPage={this.state.perPage}
                        total={total}
                        onPage={(p) => this.setState({ page: p })}
                        onPerPage={(n) => this.setState({ perPage: n, page: 1 })}
                    />
                </div>
            </div>
        );
    }
}

export default TableIndexWeb;
